import { Box, Grid, IconButton, Typography } from '@mui/material';
import React from 'react';
import DataRangePicker from 'components/DataRangePicker';
import { formatValueInBrazilianCurrency, leaveDateInFull } from 'utils';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CardInfo from 'components/CardInfo';

import DropDown from './components/DropDown';
import { Container } from './styles';

function Dashboard({
  title,
  totals,
  children,
  dateRange,
  setDateRange,
  openDropdown,
  setOpenDropdown,
  handleOpenDropdown,
  loading,
}) {
  const totalAmount =
    totals.totalDueToday + totals.totalOverdueUnpaid + totals.totalDueFuture;

  return (
    <Box pb={4}>
      <Container
        p={2}
        borderRadius={4}
        bgcolor="white"
        boxShadow="0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
      >
        <Grid container spacing={4}>
          <Grid item alignSelf="center">
            <Typography fontSize={22}>{title}</Typography>
          </Grid>
          <Grid item maxWidth={250} width="100%">
            <DataRangePicker
              dateRange={dateRange}
              inputLabel="Filtrar por período"
              setDateRange={setDateRange}
            />
          </Grid>
        </Grid>
      </Container>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs>
            <CardInfo
              loading={loading}
              title="Vencem hoje"
              value={totals.totalDueToday}
            />
          </Grid>
          <Grid item xs>
            <CardInfo
              loading={loading}
              title="Vencidos"
              value={totals.totalOverdueUnpaid}
            />
          </Grid>
          <Grid item xs>
            <CardInfo
              loading={loading}
              title="A vencer"
              value={totals.totalDueFuture}
              valueColor="#0087D7"
            />
          </Grid>
        </Grid>
      </Container>
      <Box mt="-30px" mb="-30px">
        {/* Adicionar componente de tabela como filho */}
        {children}
      </Box>
      <Container
        p={2}
        borderRadius={4}
        bgcolor="white"
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        boxShadow="0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
      >
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item>
            <Box>
              <Typography fontSize={22}>Totais do período</Typography>
              <Typography fontSize={14} color="#404944" letterSpacing="0.25px">
                {leaveDateInFull(dateRange)}
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <Box display="flex" gap={1} alignItems="center">
              <Box>
                <Typography fontSize={12}>Totais do período (R$)</Typography>
                <Typography
                  fontSize={22}
                  color="#404944"
                  letterSpacing="0.25px"
                >
                  {formatValueInBrazilianCurrency(totalAmount)}
                </Typography>
              </Box>
              <Box>
                <IconButton onClick={handleOpenDropdown} aria-label="arrow">
                  <ArrowDropDownIcon sx={{ width: 24, height: 24 }} />
                </IconButton>
                {openDropdown && (
                  <DropDown
                    open={openDropdown}
                    setOpen={setOpenDropdown}
                    totalDueToday={totals.totalDueToday}
                    totalOverdueUnpaid={totals.totalOverdueUnpaid}
                    totalDueFuture={totals.totalDueFuture}
                  />
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Dashboard;
